// extracted by mini-css-extract-plugin
export var alternate = "_p-h";
export var black = "_p-3";
export var blue = "_p-d";
export var blueLight = "_p-c";
export var brand = "_p-7";
export var error = "_p-9";
export var gray = "_p-6";
export var grayBlue = "_p-b";
export var iconWrapper = "_p-4";
export var indigo = "_p-e";
export var orange = "_p-g";
export var pink = "_p-f";
export var primary = "_p-0";
export var purple = "_p-8";
export var success = "_p-5";
export var warning = "_p-a";
export var white = "_p-1";
export var whiteSuccess = "_p-2";